import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { WarningIcon } from './SVGIcons'

/**
 * セッション期限切れモーダル
 * 403エラー時にカスタムイベント経由で表示される
 */
const SessionExpiredModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // カスタムイベントリスナーを登録
    const handleSessionExpired = () => {
      setIsOpen(true)
    }

    window.addEventListener('session-expired', handleSessionExpired)

    // クリーンアップ
    return () => {
      window.removeEventListener('session-expired', handleSessionExpired)
    }
  }, [])

  const handleLogin = () => {
    // セッションストレージをクリア
    sessionStorage.clear()

    // ログイン画面にリダイレクト
    setIsOpen(false)
    navigate('/login')
  }

  if (!isOpen) return null

  return (
    <>
      {/* 背景オーバーレイ */}
      <div className="fixed inset-0" style={{ zIndex: 10000, backgroundColor: 'rgba(0, 0, 0, 0.6)' }} />

      {/* モーダル本体 */}
      <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 10001 }}>
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
          <div className="p-6">
            {/* 警告アイコンとタイトル */}
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0">
                <WarningIcon style={{ width: '3rem', height: '3rem', color: '#eab308' }} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900" style={{ marginLeft: '1rem' }}>
                  セッションの有効期限切れ
                </h3>
              </div>
            </div>

            {/* メッセージ */}
            <div className="mb-6 text-center">
              <p className="text-base text-gray-900">
                再度ログインしてください
              </p>
            </div>

            {/* ログインボタン */}
            <div className="mt-6">
              <button
                type="button"
                onClick={handleLogin}
                className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                ログイン画面へ
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SessionExpiredModal
